import Button from './button';
import ButtonGroup from './button-group';
Button.Group = ButtonGroup;
export default Button;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/es/button/index.js
// module id = 82
// module chunks = 3